export default "__VITE_ASSET__30ca89a8__"